export default __webpack_public_path__ + "static/media/6900dd506c3ab2f9af8ab7f883638173.svg";